import React from 'react'

const ModalBackground = ({ open, dismissible, onClick }) => (
  <div
    className="fv-modal-background"
    onClick={onClick}
    style={{ display: open ? 'block' : 'none' }}
  />
)

export default ModalBackground



// WEBPACK FOOTER //
// ../src/components/fv-ui/ModalBackground.js